/* eslint-disable no-unused-expressions */
import "bootstrap/dist/js/bootstrap.min.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import "./src/styles/global.scss"

export const onClientEntry = () => {
  // Use a local sprite so controls work without external CDN requests.
  Plyr.defaults.iconUrl = "/plyr/plyr.svg";

  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (typeof window.IntersectionObserver === `undefined`) {
    import(`intersection-observer`)
    console.debug(`# IntersectionObserver is polyfilled!`)
  }
}
